const noop = Function.prototype;

let haWrapper = {
    userTiming: {
        mark: noop,
    },
};

if (typeof window !== 'undefined' && window.ha) {
    haWrapper = window.ha;
}

export default haWrapper;
